import { cva } from "class-variance-authority";

export const navList = cva(
  `w-full flex flex-col items-start p-2 tabletMedium:py-0 tabletMedium:px-size-base bg-th-primary-color-main tabletMedium:rounded-border-radius-small overflow-y-visible tabletMedium:h-[48px] tabletMedium:flex-row`
);

export const trigger = cva(
  `relative w-full h-[48px] p-0 tabletMedium:px-4 tabletMedium:py-2 flex justify-between tabletMedium:item-center tabletMedium:justify-center gap-size-base text-th-color-neutral-0`
);
